import {z} from 'zod';

export const VerificationAttemptInputSchema = z.unknown().optional();
export type VerificationAttemptInput = z.infer<typeof VerificationAttemptInputSchema>;
